import { FDSwitchInput } from '@facet-wealth/design';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';

export const SaveForRetirementOverride = buildFacetDesignOverride()
  .typeOverride('bool', {
    _component: () => FDSwitchInput,
    _customProps: { helperText: '' },
  }, overrideReadOnly);
